<template>

  <component :is="module[user.organization.orderSystem]"/>

</template>

<script>
import {IDS} from "../../Constants/IDS";
import TripsDashboard from "./TripsDashboard";
import PreOrderTrips from "../PreOrderTrips/PreOrderTrips";
export default {
  name: "Trips",
  data(){
    return{
      user: JSON.parse(localStorage.user),
      module: {
        [IDS.orderSystem.ReadyStock]: TripsDashboard,
        [IDS.orderSystem.PreOrder]: PreOrderTrips,
      }
    }
  }
}
</script>

<style scoped>

</style>